/*
Site Wishlist
*/

class SiteWishlist extends HTMLElement {
  connectedCallback() {
    this.customerId = this.dataset.customerId;
    const url = new URL(window.location.href);
    this.myParam = url.searchParams.get('id');
    this.myParamTreated = decodeURIComponent(this.myParam);
    this.wishListContainer = document.querySelector('.listed-wishlist-container');
    this.renderWishList();
  }

  async renderWishList() {
    const res = await fetch(`https://beachriot-wishlist-app.vercel.app/api/beach-riot/wishlist/${this.myParamTreated}`);
    const rawData = await res.json();
    const data = rawData.data;

    async function asyncMap(arr, asyncFn) {
      return Promise.all(arr.map(asyncFn));
    }

    async function asyncOperation(item) {
      const res = await fetch(
        `${window.location.origin}/products/${item.product.handle}?sections=product-item-small-section`
      );
      return await res.json();
    }

    asyncMap(data, asyncOperation)
      .then((results) => {
        if (results.length > 0) {
          results.forEach((result) => {
            const item = document.createElement('div');
            item.innerHTML = result['product-item-small-section'];
            this.wishListContainer.appendChild(item);
          });
        }
      })
      .catch((error) => {
        console.error('An error occurred during async operations:', error);
      });
  }
}

customElements.define('site-wishlist', SiteWishlist);
